import React from "react";
import PropTypes from "prop-types";

import Icon from "shared/react_components/MaterialIcon";
import { disqualifiedExpressionWithLabeling, expressionTextToNodeList } from "shared/utils/expressionFormatting";

export default class StaticRawExpressionResult extends React.Component {
  static propTypes = {
    qualified:                       PropTypes.bool.isRequired,
    rawExpression:                   PropTypes.string.isRequired,
    rawExpressionTitle:              PropTypes.string,
    disqualifiedExpressionListTitle: PropTypes.string
  };

  static defaultProps = {
    rawExpressionTitle:              "Results",
    disqualifiedExpressionListTitle: "Conditions Not Met"
  }

  constructor(props) {
    super(props);
    if (!this.props.qualified) {
      this.nodeList = expressionTextToNodeList(this.props.rawExpression);
      this.disqualifiedTerminals = this.nodeList.filter((node) => node.disqualified).map((node) => node.text);
    }
  }

  render() {
    if (this.props.qualified) {
      return this.renderRawQualifiedExpression();
    } else {
      return this.renderRawDisqualifiedExpression();
    }
  }

  renderRawQualifiedExpression() {
    return (
      <div>
        <h5>{this.props.rawExpressionTitle}</h5>
        <div className="code m-3" data-test-id="raw-expression-evaluated-true">
          <Icon className="color-success m-1" name="check_circle" style={{ verticalAlign: "middle" }}/>
          {this.props.rawExpression}
        </div>
      </div>
    );
  }

  renderRawDisqualifiedExpression() {
    return (
      <div>
        <h5 data-test-id="disqualified-expression-title">
          {this.props.rawExpressionTitle}
        </h5>
        <div className="code m-3" data-test-id="expression-with-labeling">
          <Icon className="color-error m-1" name="cancel" style={{ verticalAlign: "middle" }}/>
          {disqualifiedExpressionWithLabeling(this.nodeList)}
        </div>

        <h5 data-test-id="disqualified-expression-list-title">
          {this.props.disqualifiedExpressionListTitle}
        </h5>
        <ul className="list-unstyled m-3">
          {this.disqualifiedTerminals.map((terminalText) => this.terminalTextWithIcon(terminalText))}
        </ul>
      </div>
    );
  }

  terminalTextWithIcon(terminalText) {
    return (
      <li key={terminalText} className="code">
        <Icon className="color-error m-1" name="cancel" style={{ verticalAlign: "middle" }}/>
        {terminalText}
      </li>
    );
  }
}
